module.exports = __webpack_public_path__ + "static/media/header-image.67689d5b.png";